<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
// Overrides @basecom-gmbh/pond/components/ProductListing/Filter/Offcanvas/ProductListingFilterOffcanvasItem.vue
import type { Schemas } from '@shopware/api-client/api-types';
import type { ListingFilter } from '../../../types/listing/filter';
import { getTranslatedProperty } from '@shopware-pwa/helpers-next';

const props = withDefaults(
    defineProps<{
        filter: ListingFilter;
        selectedFilters: Schemas['ProductListingResult']['currentFilters'];
        showResetButton?: boolean;
        productListingStoreKey?: string;
    }>(),
    {
        productListingStoreKey: 'category',
    },
);

const { priceFilterApplied, propertyFilterApplied, propertyFilterAppliedTotal } = useProductListingCriteriaStore(
    props.productListingStoreKey,
);
</script>

<template>
    <!-- IDS-36 - Change styles-->
    <button class="flex w-full items-center justify-between pb-8 text-start">
        
<FormKitLazyProvider config-file="true">
<span class="flex gap-4">
            <template v-if="filter.code === 'properties'">
                {{ getTranslatedProperty(filter, 'name') }}
            </template>
            <template v-else>
                {{ $t(`listing.sidebar.filter.${filter.code}.title`) }}
            </template>
            <UtilityPill
                v-if="filter.code === 'price' && priceFilterApplied()"
                number="1"
            />
            <UtilityPill
                v-else-if="filter.code === 'properties' && propertyFilterApplied(filter.id)"
                :number="propertyFilterAppliedTotal(filter.id)"
            />
        </span>
        <FormKitIcon
            icon="arrow-right"
            class="block size-4"
        />
</FormKitLazyProvider>

    </button>
</template>
